import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AnamnesisGenerator from '@/pages/AnamnesisGenerator';
import Impressum from '@/pages/Impressum';
import Datenschutz from '@/pages/Datenschutz';
import EkgHelper from '@/pages/EkgHelper';
import { Toaster } from '@/components/ui/sonner';
import '@/index.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AnamnesisGenerator />} />
          <Route path="/ekg-hilfe" element={<EkgHelper />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
